import MentoringProgramsList from './MentoringProgramsList.vue';

export * from './types';
export default MentoringProgramsList;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/programslist/index.ts